import { render, staticRenderFns } from "./supplyChain.vue?vue&type=template&id=1aa41b53&scoped=true"
import script from "./supplyChain.vue?vue&type=script&lang=js"
export * from "./supplyChain.vue?vue&type=script&lang=js"
import style0 from "./supplyChain.vue?vue&type=style&index=0&id=1aa41b53&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa41b53",
  null
  
)

export default component.exports